// extracted by mini-css-extract-plugin
module.exports = {"changePasswordTypeButton":"style_changePasswordTypeButton__3bl1U"};